import { ComponentService } from "../Services/Axios/Api";

class Slider {
    data = {};
    constructor() {
        this.data = {
            id: '',
            ComponentName: 'Slider',
            isVisible: true,
            containerType: 'container',
            slides: [
                {
                    id: 1,
                    title: 'Welcome to Our Platform',
                    caption: 'Join us in making a difference through your generous donations',
                    buttons: [
                        {
                            id: 1,
                            type: "button",
                            button: {
                                text: 'Donate Now',
                                link: '/donations',
                                type: 'link',
                                buttonType: 'primary',
                                className: 'SliderBtn',
                                style: {},
                            },
                        },
                        {
                            id: 2,
                            type: "button",
                            button: {
                                text: 'Learn More',
                                link: '/about',
                                type: 'link',
                                buttonType: 'secondary',
                                className: '    ',
                                style: {},
                            },
                        }
                    ],
                    image: 'https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png',
                    order: 1
                }
            ],
            style: {
                SlideTitle: {
                    color: "#ffffff",
                },
                SlideCaption: {
                    color: "#ffffff"
                }
            },
            animation: {
                animationType: "fade-up",
                animationDuration: "1000",
                animationDelay: "100"
            },
        };
    }   

    // Id   
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }

    // Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(ComponentName) { this.data.ComponentName = ComponentName; }

    // Slides
    getSlides() { return [...this.data.slides]; }
    setSlides(slides) { this.data.slides = [...slides]; }
    
    addSlide(slide) {
        this.data.slides = [...this.data.slides, slide];
    }

    removeSlide(id) {
        this.data.slides = this.data.slides.filter(slide => slide.id !== id);
    }

    // Is Visible
    getIsVisible() { return this.data.isVisible; }
    setIsVisible(isVisible) { this.data.isVisible = isVisible; }
    toggleVisibility() { this.data.isVisible = !this.data.isVisible; }

    // Container Type
    getContainerType() { return this.data.containerType; }
    setContainerType(containerType) { this.data.containerType = containerType; }
    toggleContainerType() { this.data.containerType = this.data.containerType === 'container' ? 'container-fluid' : 'container'; }

    updateSlide(id, updatedData) {
        this.data.slides = this.data.slides.map(slide => {
            if (slide.id === id) {
                return {
                    ...slide,
                    title: updatedData.title || slide.title,
                    caption: updatedData.caption || slide.caption,
                    image: updatedData.image || slide.image,
                    order: updatedData.order || slide.order,
                    buttons: updatedData.buttons || slide.buttons
                };
            }
            return slide;
        });
    }

    // Style
    getStyle() { return this.data.style; }
    setStyle(style) { this.data.style = style; }

    // Animation
    getAnimation() { return this.data.animation || { animationType: "fade-up", animationDuration: "1000", animationDelay: "100" }; }
    setAnimation(animation) { this.data.animation = { ...this.getAnimation(), ...animation }; }
    getAnimationType() { return this.getAnimation().animationType; }
    setAnimationType(type) { this.setAnimation({ animationType: type }); }
    getAnimationDuration() { return this.getAnimation().animationDuration; }
    setAnimationDuration(duration) { this.setAnimation({ animationDuration: duration }); }
    getAnimationDelay() { return this.getAnimation().animationDelay; }
    setAnimationDelay(delay) { this.setAnimation({ animationDelay: delay }); }

    // Data
    getData() { return this.data; }
    setData(data) { this.data = data; }

    // Methods
    async load(id) {
        try {
            var response = {};
            var data = {};
            if (id) {
                response = await ComponentService.getComponentById(id);
                data = response.data ? JSON.parse(response.data) : {};
                if(Object.keys(data).length > 0){
                    this.setData(data);
                    this.setSlides(data.slides);
                    this.setStyle(data.style);
                    if (data.animation) { this.setAnimation(data.animation); }
                }
                this.setId(id);


            } else {
                 response = await ComponentService.getComponent(this.data.ComponentName);
                console.log("response",response)
                 data = JSON.parse(response[0]?.data);
                console.log("data",data)
                if(Object.keys(data).length > 0){
                    this.setData(data);
                    this.setSlides(data.slides);
                    this.setStyle(data.style);
                }
                this.setId(response[0]?.id);

            }
            
           
            return data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    // New method for language-based loading
    async loadByLanguage(language) {
        try {
            const response = await ComponentService.getStaticComponent(this.data.ComponentName, language, true);
            const data = JSON.parse(response?.data);
            
            if(Object.keys(data).length > 0){
                this.setData(data);
                this.setId(response?.id);
                this.setSlides(data.slides);
                this.setStyle(data.style);
                if (data.animation) { this.setAnimation(data.animation); }
            }
            return data;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }

    async save(id) {
        try {
            const response = await ComponentService.SaveData(id?id:this.getId(), this.getData());
            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}

export const createSliderInstance = () => new Slider();
